import { Injectable } from '@angular/core';

export interface Settings {
  localeId: string;
}

@Injectable()
export class SettingsService {
  private static LS_SETTINGS = 'settings';
  private _settings: Settings;

  constructor() {
    this._settings = this.readSettings();
  }

  get defaultLocaleId(): string {
    return 'de';
  }

  getLocaleId(): string {
    return this._settings.localeId || this.defaultLocaleId;
  }

  setLocaleId(localeId: string) {
    this._settings.localeId = localeId;
    this.writeSettings(this._settings);
  }

  private readSettings(): Settings {
    const settings = localStorage.getItem(SettingsService.LS_SETTINGS);
    if (settings !== undefined && settings !== null) {
      return JSON.parse(settings);
    }

    return {} as Settings;
  }

  private writeSettings(settings: Settings): void {
    localStorage.setItem(SettingsService.LS_SETTINGS, JSON.stringify(settings));
  }
}
